import { normalizePostStatusKey } from '@/features/content/lib/contentDisplay';

function isRejectedVerdict(verdict: string | null | undefined): boolean {
  return (verdict ?? '').toUpperCase().includes('REJECT');
}

function isEscalatedOrHumanReviewVerdict(verdict: string | null | undefined): boolean {
  const upper = (verdict ?? '').toUpperCase();
  return (
    upper.includes('ESCALAT') ||
    upper.includes('HUMAN_REVIEW') ||
    upper.includes('HUMAN REVIEW')
  );
}

function isApprovedVerdict(verdict: string | null | undefined): boolean {
  const upper = (verdict ?? '').toUpperCase();
  return upper.includes('APPROVE') || upper.includes('BYPASS');
}

/** TipMi still visible/held — final Coop reject has not applied HID yet (TM-3567). */
export function isTipmiHidePending(
  verdict: string | null | undefined,
  postStatus?: string | null,
): boolean {
  if (!isRejectedVerdict(verdict) || postStatus == null) return false;
  const key = normalizePostStatusKey(postStatus);
  return key === 'WAT' || key === 'PUB';
}

/**
 * TipMi still live — Coop escalate/human review has not applied WAT hold yet.
 * Once status is WAT, the hold is already in place (not a hide).
 */
export function isTipmiHoldPending(
  verdict: string | null | undefined,
  postStatus?: string | null,
): boolean {
  if (!isEscalatedOrHumanReviewVerdict(verdict) || postStatus == null) return false;
  return normalizePostStatusKey(postStatus) === 'PUB';
}

/** TipMi still held — final Coop approve has not applied PUB yet (TM-3571). */
export function isTipmiPublishPending(
  verdict: string | null | undefined,
  postStatus?: string | null,
): boolean {
  if (!isApprovedVerdict(verdict) || postStatus == null) return false;
  return normalizePostStatusKey(postStatus) === 'WAT';
}
